import React, { useEffect } from 'react';
import PhoneVerification from '../pages/PhoneVerification';
import saga from '../sagas';
import { store } from 'components/App';

const PhoneVerificationContainer = () => {
  useEffect(() => {
    store.injectSaga('PhoneVerificationSaga', saga);

    return () => {
      store.injectSaga('PhoneVerificationSaga', null);
    };
  }, []);

  return <PhoneVerification />;
};

export default PhoneVerificationContainer;
